import type { CSSResultGroup } from 'lit'

import tokens from '@lansforsakringar/core-tokens'
import { LitElement, css } from 'lit'

import { vars } from '#utils/styles'

export class LfuiElement extends LitElement {
	static shadowRootOptions = {
		...LitElement.shadowRootOptions,
		delegatesFocus: true
	}

	static styles: CSSResultGroup = css`
		:host {
			--ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
			--ease-in: cubic-bezier(0.4, 0, 1, 1);
			--ease-out: cubic-bezier(0, 0, 0.2, 1);

			--focus-outline: ${vars(tokens.border_width_focus)} solid
				${vars(tokens.color_border_focus_outline)};
			--focus-outline-offset: ${vars(tokens.border_width_focus)};

			font-family: ${vars(tokens.font_family_body)};
			color: ${vars(tokens.color_text_primary)};
			line-height: ${vars(tokens.line_height_body_default)};
			text-wrap: pretty;
			-webkit-font-smoothing: antialiased;

			& * {
				box-sizing: border-box;
				font-family: inherit;
				color: inherit;
				line-height: inherit;
				text-wrap: inherit;
			}
		}

		.sr-only,
		.hidden {
			border: 0;
			clip: rect(0 0 0 0);
			clip-path: inset(50%);
			height: 1px;
			margin: -1px;
			overflow: hidden;
			padding: 0;
			position: absolute;
			width: 1px;
		}
	`

	/**
	 * @description
	 * A list of event names that are emitted by the element. This is used to
	 * automatically hook up eg. a React onExpand event that is mapped to the
	 * custom expand event emitted by the custom element.
	 *
	 * @example
	 * static events = ['expand', 'collapse', 'myevent']
	 */
	static events: string[] = []
}
